import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/modals/');

export default function ListDModal() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.listD2} listD2 listD2-modal`}>
            <div className="listd-title1">{t('presale.product.modals.listD2_title1')}</div>
            <div className="listd-title2">{t('presale.product.modals.listD2_title2')}</div>
            <div className="listd-box">
                <div className="listd-item customization">
                    <div className="listd-ms-box">
                        <div className="listd-ms1">{t('presale.product.modals.listD2_title_a1')}</div>
                        <div className="listd-ms2">{t('presale.product.modals.listD2_title_a2')}</div>
                    </div>
                    <div className="listd-img">
                        <EFPic name={['listd2_1.webp', 'listd2_1.png']} className="fullImgs" alt={t('presale.product.modals.listD2_title_a1')} />
                    </div>
                </div>
                <div className="listd-item monitor">
                    <div className="listd-ms-box">
                        <div className="listd-ms1">{t('presale.product.modals.listD2_title_b1')}</div>
                        <div className="listd-ms2">{t('presale.product.modals.listD2_title_b2')}</div>
                    </div>
                    <div className="listd-img">
                        <EFPic name={['listd2_2.webp', 'listd2_2.png']} className="fullImgs" alt={t('presale.product.modals.listD2_title_b1')} />
                    </div>
                </div>
                <div className="listd-item keep">
                    <div className="listd-ms-box">
                        <div className="listd-ms1">{t('presale.product.modals.listD2_title_c1')}</div>
                        <div className="listd-ms2">
                            {t(locale === 'kr' ? 'presale.product.modals.listD2_title_c2_h5' : 'presale.product.modals.listD2_title_c2')}
                        </div>
                    </div>
                    <div className="listd-img">
                        <EFPic name={['listd2_3.webp', 'listd2_3.png']} className="fullImgs" alt={t('presale.product.modals.listD2_title_c1')} />
                    </div>
                </div>
            </div>
        </div>
    );
}
